const MS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 * Returns the number of trial days remaining, rounding partial days up so a
 * freshly started 14 day trial reads as 14 days, not 13. Ghost Admin uses the
 * same calculation for its upgrade banner (apps/admin, useUpgradeStatus) —
 * keep the two in sync so both surfaces show the same number.
 *
 * @param {string|Date|null|undefined} trialEnd
 * @returns {number} Days remaining, 0 when the trial has ended or no valid end date is given
 */
const getTrialDaysRemaining = (trialEnd) => {
    if (!trialEnd) {
        return 0;
    }

    const trialEndTime = new Date(trialEnd).getTime();
    if (Number.isNaN(trialEndTime)) {
        return 0;
    }

    return Math.max(0, Math.ceil((trialEndTime - Date.now()) / MS_PER_DAY));
};

export default getTrialDaysRemaining;
